import script from "./AdminCreateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCreateModal.vue?vue&type=script&setup=true&lang=js"

import "./AdminCreateModal.vue?vue&type=style&index=0&id=4fa18a12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fa18a12"]])

export default __exports__